import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'
import languageKey from './languageKey'

export const defaultLanguage = languageKey.th

i18n.use(initReactI18next)
    .use(Backend) // passes i18n down to react-i18next
    .init({
        fallbackLng: defaultLanguage === languageKey.th ? languageKey.en : languageKey.th,
        backend: {
            // for all available options read the backend's repository readme file
            loadPath: `${process.env.PUBLIC_URL}/language/{{lng}}.json`,
        },
        lng: defaultLanguage,
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    })

export default i18n
